import { Fragment } from 'react'
import { JoinOurCommunityContent } from './JoinOurCommunityContent'

interface IJoinOurCommunityProps {
  activeTab?: string
}

const JoinOurCommunity = ({ activeTab }: IJoinOurCommunityProps) => {
  // TODO: Add loading state when Redux is integrated
  // const getDownloadActionLoading = useAppSelector(
  //   (state) =>
  //     state.evolveLanding.loadings[thunkActionLoading.GET_DOWNLOAD_LOADING]
  // )

  return (
    <Fragment>
      <div className="bg-white p-5 pt-[60px]">
        <div>
          <>
            <JoinOurCommunityContent activeTab={activeTab} />
          </>
        </div>
      </div>
    </Fragment>
  )
}

export default JoinOurCommunity
